import styled from 'styled-components';
import Colors from 'assets/Colors.js';

const Container = styled.div` 
  background: ${Colors.background_modal};
`;


const containerShapeSelect = styled.div`
  padding: 14px;
  border-radius: 4px;
  border-color: ${Colors.background_dividers};

`;

const HeaderContainer = styled.div`
  height: 71px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${Colors.background_dividers};
  padding-left: 30px;
  padding-right: 30px;
  color: ${Colors.text_primary};
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
`;

const CloseButtonWrapper = styled.div`
  cursor: pointer;
`;

const SaveTextWrapper = styled.div`
  color: ${Colors.text_primary};
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  ${(props) => !props.enable && 'opacity: 0.3;'}
  cursor: pointer;
`;

const BodyWrapper = styled.div`
   padding: 20px 30px 10px 30px;
  //  min-height: 472px;
  // display: flex;
  // flex-direction: row;
  // @media (max-width: 1017px) {
  //   flex-direction: column;
  // }

  width: 100%;
  @media (max-width: 1017px) {
    width: 100%;
  }

`;

const SubTitle = styled.div`
  color: ${Colors.text_primary};
  font-weight: 300;
  font-size: 12px;
  line-height: 22px;
  margin-bottom: 8px;
`;

const containerButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0px;
  padding: 0px 70px 30px 70px;
  gap: 60px;
`;

const CircularButton = styled.div`
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background: ${Colors.background_secondary};

`;
const SquareButton = styled.div`
  width: 68px;
  height: 68px;
  border-radius: 10px;
  background: ${Colors.background_secondary};

`;
const RectangularButton = styled.div`
  width: 160px;
  height: 68px;
  border-radius: 10px;
  background: ${Colors.background_secondary};

`;


export default {
  Container,
  containerShapeSelect,
  HeaderContainer,
  CloseButtonWrapper,
  SaveTextWrapper,
  BodyWrapper,
  SubTitle,
  containerButtons,
  CircularButton,
  SquareButton,
  RectangularButton
};
